import { FieldDefinition, FieldBuilder } from '@zendra/shared';
import { ReasonService } from 'cbd-proxies';
import { PipelinePlannedPlantationHeaderService, PipelineStandService } from 'operational/proxy';
import { PipelinePlannedPlantationPlant } from '../pipeline-planned-plantation-plant/pipeline-planned-plantation-plant';

FieldBuilder.setNamespace('Operational');

const pipelineStandField = FieldBuilder.foreignKey(
  'pipelineStandId',
  'Cuadro',
  PipelineStandService
)
  .required()
  .display('name')
  .displayFromNested('standName')
  .sortBy('standName')
  .build();

export const PIPELINEPLANNEDPLANTATION_FIELDS: FieldDefinition[] = [
  FieldBuilder.foreignKey(
    'standReasonId',
    'Estado de cuadro',
    ReasonService
  )
    .queryFilter({ reasonGroupName: 'Estado Cuadro' })
    .display('name')
    .displayFromNested('standStatusName')
    .sortBy('standStatusName')
    .keyField('id')
    .readOnly()
    .build(),
  FieldBuilder
    .number('area', 'Area')
    .decimal()
    .readOnly()
    .build(),
  FieldBuilder.foreignKey(
    'negotiationReasonId',
    'Estado de area',
    ReasonService
  )
    .queryFilter({ reasonGroupName: 'Estado Negociación' })
    .display('name')
    .displayFromNested('areaStatusName')
    .sortBy('areaStatusName')
    .keyField('id')
    .readOnly()
    .build(),
  pipelineStandField,
  FieldBuilder.foreignKey(
    'pipelinePlannedPlantationHeaderId',
    'Entity.PipelinePlannedPlantation.PipelinePlannedPlantationHeader',
    PipelinePlannedPlantationHeaderService
  )
    .required()
    .display('id')
    .hideInChildForms()
    .hideByDefault()
    .build(),
];

export const PIPELINEPLANNEDPLANTATION_CONFIG = {
  entityName: 'PipelinePlannedPlantation',
  localizationKey: 'Operational::Entity.PipelinePlannedPlantation',
  fields: PIPELINEPLANNEDPLANTATION_FIELDS,
  permission: 'PlanningOperation.PipelinePlannedPlantations',
  showInMenu: false,
  menuCategory: '',
  menuSubcategory: '',
  children: [
      {
          entityName: 'PipelinePlannedPlantationPlant',
          foreignKeyField: 'pipelinePlannedPlantationId',
          localizationKey: 'Operational::Entity.PipelinePlannedPlantation',
          component: PipelinePlannedPlantationPlant,
      }
    ]
};
